module.exports = __webpack_public_path__ + "static/dentures-bc7039875ee0f548a75786277f7ad947.jpg";